// extracted by mini-css-extract-plugin
module.exports = {"text-area":"text-area--b5diw","textArea":"text-area--b5diw","area":"area--sxmYw","area-wrap":"area-wrap--xB_kC","areaWrap":"area-wrap--xB_kC","editable":"editable--k7iDu"};